<template>
    <section>
        <div class="container">
            <div class="row">
                <div class="col-xs-12">
                    <div class="row row-space-between row-space-top">
                        <div class="col-size-auto">
                            <h2 class="subtitle">Udvalgt Standardudstyr</h2>
                            <br />
                            <br />
                        </div>
                    </div>
                    <template v-for="category in getCategoryNames">
                        <h3 class="subtitle">{{ category }}</h3>
                        <table class="table-list">
                            <thead class="sticky-thead">
                                <tr v-if="data">
                                    <th  >
                                        <!-- should be empty -->
                                    </th>
                                    <th v-for="group in getGroupNames" :key="group + '_head'"  class="align-center">
                                        {{ group }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(standardEquipment, index) in getStandardEquipmentInCategory(category)" :key="standardEquipment.name">
                                    <td >
                                        <strong>{{ standardEquipment.name }}</strong>
                                        <div class="table-text-2">{{ standardEquipment.description }}</div>
                                    </td>
                                    <td v-for="group in data" :key="group.name + '_body_' + index" class="align-center">
                                        <svg width="8" height="8" v-if="isStandardEquipmentAvailable(group.name, category, standardEquipment.name)">
                                            <use href="/ui/icons/custom-sprite.svg#feather-dot"></use>
                                        </svg>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="100" v-html="standardEquipTermsAndConditionsText"></td>
                                </tr>
                            </tfoot>
                        </table>
                    </template>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        name: 'model-details-standard-equipment',
        props: {
            data: {
                type: Array,
                default: undefined
            },
            standardEquipTermsAndConditionsText: {
                type: String,
                default: undefined
            }
        },
        data() {
            return {
                sortKey: 'name'
            }
        },
        computed: {
            getGroupNames: function () {
                if (this.data != undefined) {
                    return this.data.map(group => group.name);
                }
                return [];
            },
            getCategoryNames: function () {
                if (this.data != undefined) {
                    const allCategoryNames = this.data.flatMap(group => group.standardEquipmentCategories.map(category => category.name));
                    return [...new Set(allCategoryNames)];
                }

                return [];
            }
        },
        methods: {
            isStandardEquipmentAvailable: function (groupName, categoryName, standardEquipmentName) {
                const standardEquipmentGroup = this.$props.data?.find(group => group.name === groupName);
                const categoryGroup = standardEquipmentGroup?.standardEquipmentCategories.find(category => category.name === categoryName);

                return categoryGroup?.standardEquipment.some(equipment => equipment.name === standardEquipmentName) || false;
            },
            getStandardEquipmentInCategory: function (categoryName) {
                if (this.data != undefined) {
                    const allEquipment = this.data.flatMap(group => group.standardEquipmentCategories.filter(category => category.name === categoryName).flatMap(category => category.standardEquipment));

                    const seen = new Set();
                    const distinctEquipment = allEquipment.filter(equipment => {
                        if (seen.has(equipment.name)) { return false; }
                        seen.add(equipment.name);
                        return true;
                    });

                    return distinctEquipment.sort((a, b) => a.name.localeCompare(b.name));
                }
            }
        }
    }
</script>